import { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { get, post } from "../../utils/apiManager";
import { baseURL } from "../../config/config";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import { useForm } from "react-hook-form";
import SuccessModal from "../../components/SuccessModal";

const Index = () => {
  const { register, handleSubmit, getValues, setValue } = useForm();
  const [allSaleCategory, setAllSaleCategory] = useState([]);
  const Navigate = useNavigate();
  const [modalData, setModalData] = useState({ message: "", show: false });

  useEffect(() => { getAllSaleCategory(); }, []);

  const getAllSaleCategory = () => {
    get(`/sale-category`)
      .then((res) => setAllSaleCategory(res?.datas))
      .catch((err) => console.log(err));
  };

  const changeStatus = (id, status) => {
    post(`${baseURL}/sale-category/status`, { id, status: !status })
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllSaleCategory(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const deleteHandler = (id) => {
    Swal.fire({ title: 'Are you sure?', text: 'This will delete the sale category.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', cancelButtonColor: '#6b7a99', confirmButtonText: 'Yes, delete it!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/sale-category/delete`, { id })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllSaleCategory(); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const pill = (active) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 100, fontSize: 11, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
      <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
    </span>
  );

  const thS = { padding: '10px 14px', fontSize: 11, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#9aa5c0', textAlign: 'left', borderBottom: '1px solid #edf0f7', background: '#f8f9fc' };
  const tdS = { padding: '12px 14px', fontSize: 14, color: '#3a4a6a', borderBottom: '1px solid #f0f2f8', verticalAlign: 'middle' };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #edf0f7' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Sale Categories</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Categories available for company sales</p>
          </div>
          <Link to="/admin/sale-category/add" style={{ textDecoration: 'none' }}>
            <button style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>+ Add Sale Category</button>
          </Link>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Name', 'Status', 'Actions'].map(h => <th key={h} style={thS}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {allSaleCategory?.length > 0 ? allSaleCategory.map((item) => (
                <tr key={item._id} onMouseEnter={e => e.currentTarget.style.background = '#fafbfd'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <td style={{ ...tdS, fontWeight: 600, color: '#0a1628' }}>{item?.name}</td>
                  <td style={tdS}>{pill(item?.isActive)}</td>
                  <td style={tdS}>
                    <div style={{ display: 'flex', gap: 5 }}>
                      <button onClick={() => changeStatus(item._id, item?.isActive)} title={item?.isActive ? 'Deactivate' : 'Activate'}
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: item?.isActive ? '#fee2e2' : '#dcfce7', color: item?.isActive ? '#b91c1c' : '#15803d', cursor: 'pointer', fontSize: 12 }}>
                        {item?.isActive ? '✕' : '✓'}
                      </button>
                      <button onClick={() => Navigate(`/admin/sale-category/edit?${item._id}`)} title="Edit"
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#eff6ff', color: '#1d4ed8', cursor: 'pointer', fontSize: 12 }}>✎</button>
                      <button onClick={() => deleteHandler(item._id)} title="Delete"
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#fee2e2', color: '#b91c1c', cursor: 'pointer', fontSize: 12 }}>🗑</button>
                    </div>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={3} style={{ ...tdS, textAlign: 'center', padding: '48px', color: '#9aa5c0' }}>No sale categories found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <SuccessModal message={modalData?.message} showModal={modalData?.show} setShowModal={setModalData} />
    </div>
  );
};

export default Index;
